import { render, staticRenderFns } from "./reclamoChat.vue?vue&type=template&id=cd13a2e6&scoped=true"
import script from "./reclamoChat.vue?vue&type=script&lang=js"
export * from "./reclamoChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd13a2e6",
  null
  
)

export default component.exports